export class ProductModel {
cmbProduct: string;
setValue(res){
if(res){
if(res['cmbProduct']){this.cmbProduct = res['cmbProduct'];}
}
}
}